<template>
    <div>
        <div class="row default-padding-top">
            <div class="col-12 col-md-4">
                <strong>Zeitpunkt</strong>
                <br>
                <span v-html="entryTimeString"></span>
            </div>
        </div>

        <template v-if="assignedEmployees">
            <hr>

            <div>
                <div><strong>Zugewiesene Mitarbeiter</strong></div>

                <div class="user-container-list no-padding">
                    <person-box-employee v-for="employee in assignedEmployees" :id="employee" :key="'assigned-employee-' + employee"/>
                </div>
            </div>
        </template>
    </div>
</template>

<script setup lang="ts">
    import PersonBoxEmployee from '../../../components/PersonBoxEmployee.vue';
    import {getEntryTimeString} from '@/library/modules/calendar/calendar';
    import {computed} from 'vue';

    const props           = defineProps<{
        entry: CalendarEntryData;
        assignedEmployees: number[];
    }>();
    const entryTimeString = computed((): string =>
    {
        return getEntryTimeString(props.entry, false);
    });
</script>